module.exports = __webpack_public_path__ + "img/portugal-digestive-diseases-male.e5e28040.png";